/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactAnalytics = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zM4 21c0-1.459.436-2.672 1.32-3.524C6.204 16.622 7.673 16 10 16h1v-2h-1c-2.674 0-4.705.72-6.07 2.037C2.565 17.356 2 19.143 2 21v1h2zm15-7v9h-2v-9zm-4 2v7h-2v-7zm8 7v-5h-2v5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgContactAnalytics as ContactAnalytics };
